import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'
import pt from './messages/pt'
import axios from 'axios'

// import en from './messages/en'

Vue.use(VueI18n)
Vue.use(VueCookies)

const locale = VueCookies.get('user_language')

const messages = {
  pt
}

export const i18n = new VueI18n({
  locale,
  messages
})

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export const loadLanguageAsync = (lang) => {
  return axios.get(`${process.env.API_URL}/translations/?language=${lang}`).then(({data}) => {
    i18n.setLocaleMessage(lang, data)
    return setI18nLanguage(lang)
  })
}



// WEBPACK FOOTER //
// ./src/lang/lang.js